import * as THREE from 'three';
import type { Vec } from '../destruction/structure';

/** Translation follows the nose during turns, instead of sliding sideways
 * toward the next waypoint while the rendered airframe slowly catches up. */
export function flightMotion(position: THREE.Vector3, rotation: THREE.Quaternion, target: Vec,
  speed: number, dt: number, reverse = false, test = false): THREE.Vector3 {
  const delta = new THREE.Vector3(target.x, target.y, target.z).sub(position), distance = delta.length();
  if (distance < 1e-5) return delta;
  const direction = delta.clone().divideScalar(distance);
  const grounded = !test && position.y < 5 && target.y < 5;
  const heading = direction.clone().multiplyScalar(reverse ? -1 : 1);
  if (grounded) heading.y = 0;
  heading.normalize();
  const desired = new THREE.Quaternion().setFromRotationMatrix(
    new THREE.Matrix4().lookAt(new THREE.Vector3(), heading, new THREE.Vector3(0, 1, 0)));
  rotation.rotateTowards(desired, (grounded ? 1.1 : 1.35) * dt);
  const forward = new THREE.Vector3(0, 0, reverse ? 1 : -1).applyQuaternion(rotation);
  if (grounded) forward.setY(0).normalize();
  const alignment = Math.max(0, forward.dot(direction));
  const pace = grounded ? alignment ** 4 : Math.max(0.18, alignment ** 2);
  const step = Math.min(distance, speed * pace * dt);
  // At a precise stop the last swept step closes the small remaining gap.
  if (alignment > 0.9995) return direction.multiplyScalar(step);
  return forward.multiplyScalar(step);
}
